<template>
  <div class="body1">
    <div class="content">
      <div class="title">CURRICULUM LEVELS</div>
      <img class="img" src="../../assets/curriculum-04.png">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 820px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: white;
  .content{
    .media-content;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title{
      width: 100%;
      text-align: left;
      color: #6D43A1;
      font-size: 30px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      font-weight: bold;
    }
    .desc{
      .title;
      color: #666666;
      font-weight: 400;
      font-size: 18px;
      margin-top: 20px;
    }
    .img{
      width: 100%;
      object-fit: contain;
      height: 526px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/curriculum/e-body2.vue